import { usePage } from "@inertiajs/react"

export type WorkspaceSubscription = {
  tier: string
  plan_key: string
  name: string | null
  interval: "month" | "year" | "lifetime"
  status: "incomplete" | "active" | "past_due" | "canceled"
  source: "stripe" | "appsumo"
  monthly_allowance: number
  allowance_remaining: number
  renews_at: string | null
  cancel_at_period_end: boolean
  // AppSumo lifetime deals only — the one-time price and where upgrades happen.
  ltd_price_cents: number | null
  manage_url: string | null
  review_url: string | null
}

export type AuthShare = {
  signed_in: boolean
  user?: { id: number; name: string; email: string; email_verified: boolean; superadmin?: boolean }
  workspace?: {
    id: number
    slug: string
    name: string
    credits_remaining: number
    subscription?: WorkspaceSubscription | null
  }
  workspaces?: { id: number; slug: string; name: string }[]
  membership_role?: "owner" | "admin" | "member"
  impersonating?: boolean
  true_user?: { id: number; name: string; email: string } | null
}

export type FlashShare = { notice?: string; alert?: string }

export type UsagePricing = {
  verification_credits_per_row: number
  basic_enrichment_credits_per_result: number
  premium_estimate_at_checkout: true
}

export type SharedProps = {
  pathname: string
  auth: AuthShare
  flash: FlashShare
  usage_pricing: UsagePricing
}

export function useShared(): SharedProps {
  return usePage<SharedProps>().props
}
